import { Box, Input, Text } from '@nimbus-ds/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

const MAX_SAVED_SEARCH_NAME_LENGTH = 20;

interface SavedSearchNameProps {
  name: string;
  onNameChange: (name: string) => void;
}

export function SavedSearchName({
  name,
  onNameChange,
}: Readonly<SavedSearchNameProps>) {
  const t = useTranslationOrders('savedSearches.creationModal');

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.value.trimStart();
    if (name.length <= MAX_SAVED_SEARCH_NAME_LENGTH) {
      onNameChange(name);
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Text>{t('name')}</Text>
      <Input
        onChange={handleNameChange}
        value={name}
        placeholder={t('example')}
      />
      <Text>
        {name.length}/{MAX_SAVED_SEARCH_NAME_LENGTH} {t('maxChars')}
      </Text>
    </Box>
  );
}
